module.exports = {"apiEndpoint":"https://sms.bornungesorg.dk/api/v1"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 152
// module chunks = 0